// extracted by mini-css-extract-plugin
module.exports = {"content-loader":"content-loader__3T148","spin":"spin__3tPs2","finitespin":"finitespin__3Y9rH"};